module.exports = __webpack_public_path__ + "img/pic1.bd05f841.png";